/**
 * Graph type registry. To add a type (e.g. a radar graph):
 * 1. add its name to `GRAPH_TYPES` in options.ts (+ defaults / scoped options),
 * 2. write `<type>/render.ts` taking `PreparedData` + `GraphOptions`,
 * 3. register it below.
 */
import { renderCombo } from './combo/render';
import { renderHeatmap } from './heatmap/render';
import { renderLine } from './line/render';
import { GraphOptions, GraphType } from './options';
import { PreparedData } from './shared/types';

export interface GraphDefinition {
    label: string;
    /** Alt text used in generated README embeds. */
    altText: string;
    render(data: PreparedData, options: GraphOptions): string;
}

export const GRAPH_DEFINITIONS: Record<GraphType, GraphDefinition> = {
    heatmap: {
        label: 'Contribution Heatmap',
        altText: 'GitHub Contribution Graph',
        render: renderHeatmap,
    },
    line: {
        label: 'Contribution Line Graph',
        altText: 'GitHub Contribution Line Graph',
        render: renderLine,
    },
    combo: {
        label: 'Contribution Bar + Line Graph',
        altText: 'GitHub Contribution Bar and Line Graph',
        render: renderCombo,
    },
};
